import script from "./SidebarMuni.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarMuni.vue?vue&type=script&setup=true&lang=js"

import "./SidebarMuni.vue?vue&type=style&index=0&id=0dd76744&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd76744"]])

export default __exports__